import React from "react";
import HospitalCard from "../HospitalCard/HospitalCard";
import { ILocationItemResponse } from "../../services/edit-hospital-location/edit-hospital-location.interface";

export interface IHospitalCardList{
  hospitalDetails: ILocationItemResponse[];
  currentHospital: any;
  onCardSelect: (data: ILocationItemResponse) => void;
}

const HospitalCardList = ({ hospitalDetails, currentHospital, onCardSelect } : IHospitalCardList) => {
  return (
    <div className="flex flex-col gap-2">
      <HospitalCard hospitalDetails={currentHospital} isHomeHospital={true}
        onCardSelect={onCardSelect} />
      {hospitalDetails.filter((hospital)=>!hospital.isOnlyUrgentVisit).map((hospital:any, index:number)=>(
        hospital.idLocation !== currentHospital.idLocation && <HospitalCard key={index} hospitalDetails={hospital}
          onCardSelect={onCardSelect} />
      ))}
    </div>
  );
};

export default HospitalCardList;
